import { useState } from "react";
import AddItem from "./AddItem";
import ItemsList from "./ItemList";
import { createGlobalStyle } from "styled-components";
import styled from "styled-components";

const GlobalStyle = createGlobalStyle`
  *{margin: 0; padding: 0;}
  
  body{background-color: #F3E7DD;}

  h1{padding: 30px; background-color black; color: white; margin-bottom: 10px; text-align: center;}

  ul{display: flex; flex-wrap: wrap;}
`;

const WrapDiv = styled.div`
  width: 70%;
  margin: 0 auto;
`;

function App() {
  const [items, setItems] = useState([
    { id: 0, value: "기본 스타일 적용" },
    { id: 1, value: "추가 기능 구연" },
    { id: 2, value: "수정 기능 구연" },
    { id: 3, value: "삭제 기능 구연" },
  ]);

  const handleDelete = (id) => {
    setItems(items.filter((item) => item.id !== id));
  };

  const addItem = (itemId, itemValue) => {
    setItems([...items, { id: itemId, value: itemValue }]);
  };

  const changeItem = (itemId, itemValue) => {
    const nextItem = items.find((item) => item.id === itemId);
    nextItem.value = itemValue;
  };

  return (
    <>
      <GlobalStyle />
      <h1>To Do List 기본 기능</h1>
      <WrapDiv>
        <AddItem addItemList={addItem} />
        <ItemsList
          items={items}
          onDelete={handleDelete}
          onChange={changeItem}
        />
      </WrapDiv>
    </>
  );
}

export default App;
